import SuspenseLoading from "../containers/SuspenseLoading";

const SuspenseScreen = () => {
    return(
        <SuspenseLoading/>
    );
}

export default SuspenseScreen;